//
import StateModel from '@/models/General/GState'
import UserModel from '@/models/General/GUser'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'

//
export default [
  {
    name: 'id',
    type: 'text-field',
    props: {
      label: 'Id',
    },
  },
  {
    name: 'g_user_id',
    type: 'autocomplete-model',
    props: {
      hideDetails: true,
      itemText: 'full_name',
      itemValue: 'id',
      label: 'Usuario',
      model: UserModel,
      noObject: true,
      paramSearch: 'search',
    },
  },
  {
    name: 'wh_warehouse_id',
    type: 'autocomplete-model',
    props: {
      hideDetails: true,
      itemText: 'name',
      itemValue: 'id',
      label: 'Bodega',
      model: WarehouseModel,
      noObject: true,
      paramSearch: 'search',
    },
  },
  {
    name: 'g_state_id',
    type: 'autocomplete-model',
    props: {
      hideDetails: true,
      itemText: 'state',
      itemValue: 'id',
      label: 'Estado',
      model: StateModel,
      noObject: true,
      paramFilter: {
      	g_state_type_id: 7,
      },
      paramSearch: 'state',
    },
  },
  {
    name: 'inventory_date_min',
    type: 'date-field',
    props: {
      label: 'Desde',
    },
  },
  {
    name: 'inventory_date_max',
    type: 'date-field',
    props: {
      label: 'Hasta',
    },
  },
]
